import { default as OpenCvSnack } from './OpenCvSnack';
export default OpenCvSnack;